<template>
  <div class="row items-center no-wrap">
    <q-input
      :model-value="value"
      :disable="isLoading"
      debounce="1000"
      dense
      outlined
      input-class="text-center"
      type="number"
      min="0"
      style="width: 100px"
      @update:modelValue="onInputChange"
    >
      <template v-slot:append>
        <q-btn
          icon="fa fa-plus"
          :loading="isLoading"
          :disable="isLoading"
          flat
          dense
          round
          size="xs"
          color="primary"
          @click="increment"
        >
          <q-tooltip>Add 1 free trial</q-tooltip>
        </q-btn>
      </template>
    </q-input>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import notify from '@/components/notify';
import { updateNumFreeTrials } from '@/iam/account';
import { HasTaskMixin } from '@/mixins';
import { Account } from '../types';

interface Data {
  task: Promise<Account> | null;
}

export default defineComponent({
  emits: ['updated'],
  mixins: [HasTaskMixin],
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    onInputChange(value: string | number | null) {
      this.performUpdate(Number(value) || 0);
    },
    async increment() {
      await this.performUpdate(this.value + 1);
    },
    async performUpdate(numOfFreeTrials: number) {
      if (this.isLoading) return;

      this.task = updateNumFreeTrials(this.accountId, numOfFreeTrials);

      this.task!.then(({ numFreeTrials: newValue }) => {
        this.$emit('updated', newValue);
      })
        .catch(() => {
          notify({ message: 'Failed to update number of free trials', color: 'error' });
        });
    },
  },
});
</script>
